import { useMemo } from 'react';
import { activateBooks, BOOKS_SLUG } from '@givmo/books';
import { isBooksModuleEnabled } from '../../lib/env';

/** Stable for this org: the shared panel cancels its run when the handler changes. */
export function useBooksActivation(orgRef: string | null) {
  const enabled = isBooksModuleEnabled();
  return useMemo(
    () =>
      orgRef === null || !enabled
        ? undefined
        : async (module: string) => {
            if (module !== BOOKS_SLUG) throw new Error('No activation handler for this app');
            return activateBooks(orgRef);
          },
    [orgRef, enabled],
  );
}
